import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_BATCH = 'LOAD_BATCH'
export const INATIVAR_FORNECEDOR = 'INATIVAR_FORNECEDOR'
export const RESET_STATE = 'RESET_STATE'
export const BOOTSTRAP_FORNECEDOR_RELATORIO = 'BOOTSTRAP_FORNECEDOR_RELATORIO'

const getDefaultState = () => {
  return {
    fornecedores: null,
    loading: false,
    listFornecedores: [],
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_BATCH] ({ commit, state }) {
    await api.listEntidade('fornecedor').then(
      response => {
        const fornecedores = response.map(item => {
          return {
            ...item,
            nome_razao_social: item.pessoaFis ? item.nome : item.razao_social,
            cpf_cnpj: item.pessoaFis ? item.cpf : item.cnpj,
          }
        })
        commit(SET_STATE, { fornecedores })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch, commit, state }) {
    commit(SET_STATE, { loading: true })
    await dispatch(LOAD_BATCH)
    commit(SET_STATE, { loading: false })
  },
  async [INATIVAR_FORNECEDOR] ({ dispatch, commit, state }, fornecedor) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir a Empresa?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('fornecedor', fornecedor.id).then(
          result => result,
          (error) => {
            Swal.fire({
              icon: 'warning',
              title: 'Atenção!',
              text: error.message
                ? error.message
                : 'Não foi possivel excluir a Empresa!',
            })
          },
        )
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'A Empresa foi excluído com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2500,
        })
        dispatch(BOOTSTRAP)
      }
    })
  },

  async [BOOTSTRAP_FORNECEDOR_RELATORIO] ({ dispatch, commit, state }) {
    commit(SET_STATE, { listFornecedores: [] })

      await api.listEntidade('fornecedor/filtro').then(
      listFornecedores => {
        commit(SET_STATE, { listFornecedores })
      },
    )
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
